module.exports = __webpack_public_path__ + "static/media/international-competition-2.1.2fae307c.jpg";